export default "__VITE_ASSET__CkyiErkO__"